import api from "./api";

export const getGalleries = async (params) => {
  return api
    .get({
      endpoint: "/own/images/venue/list",
      port: process.env.REACT_APP_PORT_IMG,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
